'use client';

import { withVerticalScope } from '@hyphengroup/cms-components/utils/cmsPageContext';
import { CardListingWrapperBase } from './CardListingWrapperBase';
import { CardListingWrapperCar } from './CardListingWrapperCar';
import { CardListingWrapperPersonalLoan } from './CardListingWrapperPersonalLoan';
import { CardListingWrapperTravel } from './CardListingWrapperTravel';
import { CardListingWrapperProps } from './types';
import { getProductBlockVertical } from '$/components/cms/helpers/productBlockVertical';
import { usePdpModalConfigProps } from '$/components/cms/helpers/useProductDetailModal';

const CardListingWrapperSwitch: React.FC<CardListingWrapperProps> = (
  rawProps,
) => {
  // The #usePDP modal config fetcher travels as a prop down to SectionGifts
  // (CMS-1924); injected once here so the four vertical variants stay dumb.
  const props = { ...rawProps, ...usePdpModalConfigProps() };
  switch (props.vertical) {
    case 'CAR_INSURANCE':
      return <CardListingWrapperCar {...props} />;
    case 'TRAVEL_INSURANCE':
      return <CardListingWrapperTravel {...props} />;
    case 'PERSONAL_LOANS':
      return <CardListingWrapperPersonalLoan {...props} />;
    default:
      return <CardListingWrapperBase {...props} />;
  }
};

// A block's products can belong to another vertical than the page's (CMS-1987).
const CardListingWrapper = withVerticalScope(
  CardListingWrapperSwitch,
  (props) => getProductBlockVertical(props.metadata?.product_card),
);

export default CardListingWrapper;
